
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[vanity]",
      function () {
        return require("private-next-pages/[vanity].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[vanity]"])
      });
    }
  